export default __webpack_public_path__ + "static/media/FXS.397c1c21.png";